<template>
  <v-card :loading="loading.timeline" :disabled="loading.timeline">
    <v-card-title class="subheading font-weight-bold">
      Timeline
      <v-spacer />
      <v-row class="mx-1 ml-0">
        <template>
          <v-btn
            v-if="!completed"
            dark
            small
            class="mx-1"
            color="green"
            @click="conclude()"
          >
            <v-icon small left>mdi-check-circle-outline</v-icon>Concluir
          </v-btn>
          <v-btn dark small class="mx-1" color="orange" @click="create()">
            <v-icon small left>mdi-email-plus</v-icon>Enviar E-mail
          </v-btn>
          <v-btn
            dark
            small
            class="mx-1"
            color="brown"
            @click="createregistro()"
          >
            <v-icon small left>mdi-cellphone-message</v-icon>Registrar
            Ocorrência
          </v-btn>
          <v-btn dark small class="mx-1" color="blue" @click="load()">
            <v-icon small left>mdi-refresh</v-icon>
            ATUALIZAR
          </v-btn>
        </template>
      </v-row>
    </v-card-title>

    <v-divider></v-divider>

    <v-container fluid>
      <v-timeline
        v-if="timeline.length > 0"
        reverse
        :dense="$vuetify.breakpoint.smAndDown"
      >
        <v-timeline-item
          v-for="item in items"
          :key="item.id_trat_base"
          :color="item.id_status === 2 ? 'green' : status[item.ID_TIPO].color"
          :icon="
            item.id_status === 2
              ? 'mdi-check-circle-outline'
              : status[item.ID_TIPO].icon
          "
          :left="status[item.ID_TIPO].left"
          :right="status[item.ID_TIPO].right"
          fill-dot
        >
          <v-card>
            <v-card-text class="body-1 text--primary">
              <p :title="item.tratativa">{{ item.tratativa }}</p>
            </v-card-text>

            <v-card-actions class="caption text--secondary">
              {{
                new Date(item.data_trat).toLocaleDateString()
              }}</v-card-actions
            >
          </v-card>
          <v-list dense slot="opposite" v-if="item.id_status !== 2">
            <!-- <v-list-item>
              <v-list-item-content
                >Previsão de conclusão
                {{ item.data_prev_conclusao | date }}</v-list-item-content
              >
            </v-list-item> -->
          </v-list>
        </v-timeline-item>
      </v-timeline>
      <v-row v-else justify="center" align="center">{{
        loading.timeline ? "Carregando..." : "Nenhuma tratativa até agora"
      }}</v-row>
    </v-container>
    <Create />
    <Createregistro />
    <Conclude />
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

import Create from "@/components/tratativa/create";
import Createregistro from "@/components/tratativa/createregistro";
import Conclude from "@/components/tratativa/conclude";

export default {
  name: "Timeline",

  components: { Create, Conclude, Createregistro },

  data: () => ({
    status: {
      1: {
        color: "brown",
        icon: "mdi-cellphone-message",
        class: "flex-row-reverse",
        left: true,
        right: false,
      },
      2: {
        color: "orange",
        icon: "mdi-email-plus",
        class: "flex-row-reverse",
        left: true,
        right: false,
      },
      3: {
        color: "red",
        icon: "mdi-message-text-fast-outline",
        class: "flex-row",
        left: false,
        right: true,
      },
    },
    // comentario_do_pedido: "",
  }),

  computed: {
    ...mapState(["timeline", "loading"]),

    items() {
      return [...this.timeline].reverse();
    },

    completed() {
      const last = this.timeline[this.timeline.length - 1];
      return last && last.id_status === 2;
    },
  },

  methods: {
    ...mapMutations(["setDialog"]),
    ...mapActions(["getTimeline", "getData"]),

    create() {
      this.setDialog({ dialog: { create: true } });
    },

    createregistro() {
      this.setDialog({ dialog: { createregistro: true } });
    },

    conclude() {
      this.setDialog({ dialog: { conclude: true } });
    },

    load() {
      this.getTimeline();
    },

    async getInterviewData() {
      const response = await fetch(
        `https://fkxxb5k2vh.execute-api.sa-east-1.amazonaws.com/dev/entrevista`,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
            Authorization: process.env.VUE_APP_AUTHORIZATION,
          },
          body: JSON.stringify({
            page: "1",
            rows: "1",
            id: this.details.id,
          }),
        }
      );
      const data = await response.json();
      // console.log("teste1:", data);
      if (data.items.length) {
        this.colorStyle = this.setColorStyle(data.items[0].marca);
        // console.log("teste2:", data.items[0]);
        // this.EMAIL_LOJA = data.items[0].EMAIL_LOJA;
        // this.marca = data.items[0].marca;
        // this.nome = data.items[0].nome;
        // this.comentario_do_pedido = data.items[0].comentario_do_pedido;
      }
    },
  },

  filters: {
    date: (str) => new Date(str).toLocaleDateString(),
  },
  async beforeMount() {
    // console.log("estou aqui");
    const id = JSON.parse(atob(this.$route.params.id));
    // console.log("estou aqui tbm", id);
    this.setDetails({ details: { id } });
    await this.getInterviewData();
    await this.getTimeline();
    this.ready = true;
  },
};
</script>

<style scoped>
.container {
  max-height: 75vh;
  overflow: auto;
}
</style>